import { Component, OnInit, ViewChild,ElementRef } from '@angular/core';
import {formatDate, DatePipe} from '@angular/common';
import { LeadsService } from '../_service/leads.service';
import { SharedService } from '../_service/shared.service';
import { MiscService } from '../_service/misc.service';
import { PageEvent, MatPaginator } from '@angular/material/paginator';
import { NgModel } from '@angular/forms';
import * as XLSX from 'xlsx';
declare var $: any;
@Component({
  selector: 'app-recordinglog',
  templateUrl: './recordinglog.component.html',
  styleUrls: ['./recordinglog.component.css']
})
export class RecordinglogComponent implements OnInit {
  leads:any=[];perpage:number=25;length:number=0;pageEvent: PageEvent;loading:boolean=true;pageSizeOptions = [10,25,50,100,250];pageIndex:number=0;loaded:boolean=false;myrole:string;isCMAccess:string;hideColumn:any;leadallStatus=[];allbds=[];leadStatus_copy=[];bds_copy=[];circles_copy=[];treatments_copy=[];alltreatments=[];treatments=[];lead_category_filter='';treatCategory=[];leadStatus=[];circles=[];lead_sources=[];sheetCircle=[];bds=[];search:string;lead_status:string;bd:string;start_date:string='';end_date:string='';circle='';treatment='';payment_mode:string;lead_source:any;start_date_follow_up:string='';end_date_follow_up:string='';c2crecording:string;
  id = 'hotInstance'; settings = {colHeaders: true };
  @ViewChild('paginatorBottom', {static: false}) paginatorBottom: MatPaginator;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild('dateRangeStart', {static: false}) dateRangeStart: ElementRef;
  @ViewChild('dateRangeEnd', {static: false}) dateRangeEnd: ElementRef;
  @ViewChild('followupdateRangeStart', {static: false}) followupdateRangeStart: ElementRef;
  @ViewChild('followupdateRangeEnd', {static: false}) followupdateRangeEnd: ElementRef;
  constructor(private leadapi:LeadsService,private sharedapi:SharedService,public miscapi:MiscService,private datepipe:DatePipe) {
    this.getbds();this.getcircle();this.getLeadSources();
    this.getleadStatus();this.getTreatment();this.getTreatmentCategory();
    this.loadCommonData();
  }

  async loadCommonData()
  {
      await this.leadapi.getCommonData().subscribe((data:any) => {
          if(data.status)
          {
              this.treatments = data.treatment;
              this.bds = data.bd;
              this.leadStatus = data.lead_status;
              this.sheetCircle = data.circle;
          }else{
              this.leadStatus = [];
          }
      }, error => {
          this.sharedapi.checkError(error);
      });
  }

  async getLeadSources()
  {
    let uri = 'none';
    this.leadapi.getUpdatedLeadSources(uri).subscribe((data:any) => {
        if(data.status)
        {
            this.lead_sources = data.data;
        }else{
            this.lead_sources = [];
        }
    }, error => {
        this.sharedapi.checkError(error);
    });
  }
  
  async getleadStatus()
  {
      await this.leadapi.getLeadStatus().subscribe((data:any) => {
          if(data.status)
          {
              this.leadallStatus = data.data;
              this.leadStatus_copy = this.leadallStatus;
          }else{
              this.leadallStatus = [];
          }
      }, error => {
          this.sharedapi.checkError(error);
      });
  }

  async getbds(status=1)
  {
      await this.leadapi.getbds(status).subscribe((data:any) => {
          if(data.status)
          {
              this.allbds = data.data;
              this.bds_copy = this.allbds;
          }else{
              this.allbds = [];
          }
      }, error => {
          this.sharedapi.checkError(error);
      });
  }

  async getTreatment()
  {
      await this.leadapi.getTreatments().subscribe((data:any) => {
          if(data.status)
          {
              this.alltreatments = data.data;
              this.treatments_copy = this.alltreatments;
          }else{
              this.alltreatments = [];
          }
      }, error => {
          this.sharedapi.checkError(error);
      });
  }

  async getTreatmentCategory()
  {
      await this.miscapi.getTreat_Category().subscribe((data:any) => {
          if(data.status)
          {
              this.treatCategory = data.data;
          }else{
              this.treatCategory = [];
              this.sharedapi.presentToast(data.msg);
          }
      }, error => {
          this.sharedapi.checkError(error);
      });
  }

  async getcircle()
  {
      await this.leadapi.getcircles().subscribe((data:any) => {
          if(data.status)
          {
              this.circles = data.data;
              this.circles_copy = this.circles;
          }else{
              this.circles = [];
          }
      }, error => {
          this.sharedapi.checkError(error);
      });
  }

  searchOnSelect(searchtText: string, type){
    if (type == 'lead_status') {
        this.leadallStatus = this.sharedapi.searchData(searchtText, this.leadStatus_copy, "name");
    }else if(type == 'bds'){
        this.allbds = this.sharedapi.searchData(searchtText, this.bds_copy, "name");
    }else  if (type == 'circle') {
        this.circles = this.sharedapi.searchData(searchtText, this.circles_copy, "name");
    }else  if (type == 'treatment') {
        this.alltreatments = this.sharedapi.searchData(searchtText, this.treatments_copy, "name");
    }else  if (type == 'treatment_modal') {
        this.alltreatments = this.sharedapi.searchData(searchtText, this.treatments_copy, "name");
    }
  }

  setSearchValue(type){
    if(type=='lead_status'){
        $("#lead_status_Search").val('');
        $("#lead_status_Search").focus();
        this.leadallStatus= this.leadStatus_copy;
    }else if(type=='bds'){
        $("#bd_search").val('');
        $("#bd_search").focus();
        this.allbds= this.bds_copy;
    }else if(type=='circle'){
        $("#circleSearch").val('');
        $("#circleSearch").focus();
        this.circles= this.circles_copy;
    }else if(type=='treatment'){
        $("#treatmentSearch").val('');
        $("#treatmentSearch").focus();
        this.alltreatments= this.treatments_copy;
    }else if(type=='treatment_modal'){
        $("#treatmentModalSearch").val('');
        $("#treatmentModalSearch").focus();
        this.alltreatments= this.treatments_copy;
    }
  }

  selectAll(select: NgModel) {
    let values: any[] = []; 
    for(let group of this.allbds){
      values.push(group.id);
    }
    let data = values.map(x=>`${x}`).toString().split(',');
    select.update.emit(data);
    this.loadleads(0,this.perpage);

  }

  deselectAll(select: NgModel) {
    select.update.emit([]);
    this.loadleads(0,this.perpage);
  }

  dateRangeChange(date1,date2)
  {
    if(date2.value)
    {
        this.start_date = date1.value;
        this.end_date = date2.value;
    }
  }

  clearDate()
  {
    this.dateRangeStart.nativeElement.value = "";
    this.dateRangeEnd.nativeElement.value = "";
    this.start_date = '';
    this.end_date = '';
  }

  dateRangeChangefollowUp(date1,date2)
  {
    if(date2.value)
    {
        this.start_date_follow_up = date1.value;
        this.end_date_follow_up = date2.value;
    }
  }

  clearDateFollowUp()
  {
    this.followupdateRangeStart.nativeElement.value = "";
    this.followupdateRangeEnd.nativeElement.value = "";
    this.start_date_follow_up = '';
    this.end_date_follow_up = '';
  }

  resetFilters(){
    this.clearDate();
    this.clearDateFollowUp();
    this.search = ''; this.lead_source = '';  this.lead_status = ''; this.bd = ''; this.circle = ''; this.treatment = ''; this.lead_category_filter = ''; this.payment_mode = ''; this.c2crecording=''; 
    this.loadleads(0,25);
  }

  toJson(json)
  {
      return JSON.parse(json);
  }

  ngOnInit(): void {
    this.sharedapi.getRole()
    .subscribe((item:string) => {this.myrole=item;});
    this.myrole = localStorage.getItem('role');
    this.isCMAccess = localStorage.getItem('CMAccess');
  }

  ngAfterViewInit() {
    this.loadleads(0,25);
  }

  pageChange(event)
  {
      this.pageIndex = event.pageIndex;
      this.loadleads(event.pageIndex,event.pageSize);
  }

  public getServerData(event:PageEvent):any
  {
      this.perpage = event.pageSize;
      this.pageIndex = event.pageIndex;
      this.loadleads(event.pageIndex,event.pageSize);
  }

  async loadleads(pageIndex,perpage)
  {
    this.leads = [];
    this.paginator.pageIndex = pageIndex;
    this.paginatorBottom.pageIndex = pageIndex;
    this.pageIndex = pageIndex;
    this.loading = true;this.loaded = false;

    let qString = 'search='+this.search+'&circle='+this.circle+'&treatment='+this.treatment+'&lead_status='+this.lead_status+'&bd='+this.bd+'&lead_source='+this.lead_source+'&date_range='+this.start_date+'-'+this.end_date+'&payment_mode='+this.payment_mode+'&lead_category_filter='+this.lead_category_filter+'&follow_up_date_range='+this.start_date_follow_up+'-'+this.end_date_follow_up+'&c2crecording='+this.c2crecording;
    this.leadapi.getRecordingLogs(pageIndex,perpage,qString).subscribe((data:any) => {
      this.length = parseInt(data.totaldata);
      this.loading = false;
      this.loaded = true;
      if(data.status)
      {
        this.leads = data.data;
      } else  {
        this.leads = [];
        this.sharedapi.presentToast(data.msg);
      }
    }, error => {
      this.loading = false;
      this.loaded = true;
      this.sharedapi.checkError(error);
    });
  }

  exportRecordingLeadData()
  {
    if(this.leads.length>0)
    {
      let data = [];
      /* let titles = [
        'Glamyo Patient Id', 'Lead Source', 'Lead Status', 'Lead Location', 'Circle', 'Lead Owner','Employee Id', 'Treatment', 'Description', 'Lead Time', 'First Action Log','Follow-up Date', 'Kaleyra Recording Links', 'Kaleyra C2C Recording Links', 'Nimbus C2C Recording Links'
      ]; */
      let titles = [
        'Glamyo Patient Id', 'Lead Source', 'Lead Status', 'Lead Location', 'Circle', 'Lead Owner','Employee Id', 'Treatment', 'Description', 'Lead Time', 'Follow-up Date',  'Nimbus C2C Recording Links'
      ];
      data.push(titles);
      for(let key in this.leads)
      {

        /*********For First Action Log**************** */
        /* let first_action_arr = [];
        if(this.leads[key].first_action_json){
          first_action_arr = JSON.parse(this.leads[key].first_action_json)
        }
        let first_action_log_data = '';
        if(first_action_arr)
        {
          for(let fact in first_action_arr)
          {
            if(first_action_arr[fact].first_action_message)
            {
              let first_action_on = formatDate(first_action_arr[fact].first_action_date_time*1000, 'dd MMM, yyyy hh:mm aa', 'en-US');
              first_action_log_data += 'First Action on:- '+first_action_on+' \n Message:-'+first_action_arr[fact].first_action_message.replace(/<[^>]*>/g, '');
            }
          }
        } */
        /*****For Kaleyra Call Recording************ */
        /* let call_det_arr = [];
        if(this.leads[key].call_details){
          call_det_arr = JSON.parse(this.leads[key].call_details)
        }
        let kal_recording_url = '';
        if(call_det_arr)
        {
          for(let callD in call_det_arr)
          {
            if(call_det_arr[callD].call_recording_url)
            {
              kal_recording_url += call_det_arr[callD].call_recording_url+'\n';
            }
          }
        } */

        /*****For Kaleyra C2C Recording************ */
        /* let kal_cc_det_arr = [];
        if(this.leads[key].total_click_to_call){
          kal_cc_det_arr = JSON.parse(this.leads[key].total_click_to_call)
        }
        
        let kal_cc_recording_url = '';
        if(kal_cc_det_arr)
        {
          for(let kcallD in kal_cc_det_arr)
          {
            if(kal_cc_det_arr[kcallD].kcc_recording)
            {
              kal_cc_recording_url += kal_cc_det_arr[kcallD].kcc_recording+' (Duration:-'+kal_cc_det_arr[kcallD].kcc_duration+') \n';
            }
          }
        } */
        
        /*****For Nimbus C2C Recording************ */
        let nim_cc_det_arr = [];
        if(this.leads[key].total_nimbus_click_to_call){
          nim_cc_det_arr = JSON.parse(this.leads[key].total_nimbus_click_to_call)
        }

        let nim_cc_recording_url = '';
        if(nim_cc_det_arr)
        {
          for(let ncallD in nim_cc_det_arr)
          {
            if(nim_cc_det_arr[ncallD].ncc_recording)
            {
              nim_cc_recording_url += nim_cc_det_arr[ncallD].ncc_recording+' (Duration:-'+nim_cc_det_arr[ncallD].ncc_duration+') \n';
            }
          }
        }
          
        let exdata = [
          this.leads[key].glamyo_patient_id,
          this.sharedapi.getLeadSource(this.leads[key].lead_source),
          this.leads[key].lead_status_name,
          this.leads[key].city_name,
          this.leads[key].circle_name,
          this.leads[key].bd_name,
          this.leads[key].employee_id,
          this.leads[key].treatment_name,
          this.leads[key].description,
          this.leads[key].lead_date_time,
          /* first_action_log_data, */
          this.leads[key].followup_date,
          /* kal_recording_url, */
          /* kal_cc_recording_url, */
          nim_cc_recording_url
        ];
        data.push(exdata);
      }
      let ws = XLSX.utils.aoa_to_sheet(data);
      /* generate workbook and add the worksheet */
      const wb: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

      let date=new Date();
      let latest_date =this.datepipe.transform(date, 'yyyy_MM_dd_HH_mm_ss');
      /* save to file */
      XLSX.writeFile(wb, 'nimbus_recording_logs_'+latest_date+'.xlsx');
    } else {
      this.sharedapi.presentToast('No data found!');
    }
  }

}
